import React from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { ExamTemplate } from 'models/ExamTemplateModel';
import { create } from 'domain';


const ExamTemplateList: React.FC = () => {
  const width = { name: 30, doctor: 30, comment: 30, date:10 };
  const [formId, formName] = [Code.Form.Id.EXAMTEMPLATE, Code.Form.Name.EXAMTEMPLATE];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, rows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, iframeRef2, filterRef, contextMenuRef  } = useListContext();
  const [examTemplateData, setExamTemplateData] = useState<ExamTemplate[]>([]); 
  const [selectedExamTemplate, setselectedExamTemplate] = useState<ExamTemplate | null>(null);
  const triggers = [pno, rows, search, activeId];
  const Privilege = Hooks.Privilege.List(formId);
  const userId = Utility.Storage.UserId();

  Hooks.Privilege.HasView(Privilege);
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, rows, Name.ExamTemplate.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.ExamTemplate.Id, 
        Name.ExamTemplate.Date,
        Name.ExamTemplate.Name,
        Name.ExamTemplate.Comment,
        Name.Doctor.FullName, 
        Name.ExamTemplate.Data,
      ]),
      user_id: userId,
    });
     
    await API.Data.List<ExamTemplate>(url, setExamTemplateData, setError, setLoading); 
  }, triggers);

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.State} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, examTemplateData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                [Title.Name, width.name],
                [Title.Doctor, width.doctor], 
                [Title.Comment, width.comment], 
                [Title.Date, width.date], 
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(examTemplateData) && (
              <Control.Grid.Row>
                {examTemplateData.map((examTemplateData) => { const path = Utility.Join.Edit(Privilege, formName, examTemplateData.examtemplate_key); return (
                <Control.Grid.Data<ExamTemplate> key={examTemplateData.examtemplate_id} itemKey={examTemplateData.examtemplate_key} data={examTemplateData} setMenuPosition={setMenuPosition} setSelectedData={setselectedExamTemplate} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={examTemplateData.examtemplate_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, examTemplateData.examtemplate_key)} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Items values={[
                    [examTemplateData.examtemplate_name, width.name], 
                    [Utility.Get.FullName(examTemplateData,Code.Form.Name.DOCTOR), width.doctor],
                    [examTemplateData.examtemplate_comment, width.comment],
                    [Utility.Format.DateOnly(examTemplateData.examtemplate_date), width.date],
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={examTemplateData.examtemplate_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={rows} loading={loading} error={error} dataLength={examTemplateData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName,selectedExamTemplate?.examtemplate_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedExamTemplate?.examtemplate_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Control.FormPopup2 iframeRef={iframeRef2} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default ExamTemplateList;